import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Servis = {
	name: NAME,
	apiProvider,
	router,
};
